import React from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';
import BackgroundImage from 'gatsby-background-image';

import ContentContainer from '../../components/ContentContainer/ContentContainer';
import WideContainer from '../../components/WideContainer/WideContainer';
import Image from '../../components/Image/Image';
import Typography, {
  TypographyContextProvider,
} from '../../components/Typography/Typography';

import { theme } from '../../styles/theme';
import { HeaderHeroImageSectionStoryblok } from '../../types/storyblok';

const StyledImage = styled(Image)`
  height: var(--mobile-height);
  display: flex;
  justify-content: center;
  align-items: ${(props) => (props.$withTitle ? 'flex-end' : 'center')};

  @media (min-width: ${theme.breakpoint.lg}) {
    height: var(--desktop-height);
  }
`;

const StyledBackdrop = styled(Box)`
  position: absolute;
  top: 0;
  z-index: -1;
  height: var(--mobile-height);

  @media (min-width: ${theme.breakpoint.lg}) {
    height: var(--desktop-height);
  }
`;

/**
 * Renders a <HeaderHeroImageSection /> component
 * @param {Object} props
 * @param {string} [props.Backdrop]
 * @param {string} props.HeroImage
 * @param {string} [props.Label]
 * @param {boolean} [props.LightText]
 * @param {string} [props.LogoImage]
 * @param {string} [props.OverlayColour]
 * @param {string} [props.Title]
 */
const HeaderHeroImageSection = ({
  Backdrop = 'transparent',
  HeroImage,
  HeroImageNew,
  Label,
  LightText,
  LogoImage,
  OverlayColour = '#fff6',
  Title,
}: HeaderHeroImageSectionStoryblok) => (
  <TypographyContextProvider
    value={{ colourScheme: LightText ? 'dark' : undefined }}
  >
    <Box
      sx={{
        '--mobile-height': '50vh',
        '--desktop-height': '65vh',
      }}
      className="!mx-auto !mt-5 flex max-w-standard justify-center overflow-hidden rounded-[5px]"
    >
      {/* 130px is from Header.js - 45px padding, top & bottom + 30/40px logo height */}
      <StyledImage
        $withTitle={Boolean(Title)}
        blurLoad
        ImgToRender={BackgroundImage}
        isBackgroundImage
        isHighQuality
        minSize="600x0"
        src={HeroImage}
        {...(HeroImageNew && HeroImageNew[0])}
        className="w-full"
      >
        <StyledBackdrop
          sx={{
            backgroundImage: `
              linear-gradient(to bottom, ${OverlayColour} 10%, transparent),
              linear-gradient(to bottom, ${Backdrop}, ${Backdrop})
            `,
          }}
          className="w-full"
        />
        {LogoImage && (
          <Box width={['90vw', '50vw']}>
            <Image src={LogoImage} />
          </Box>
        )}
        {Title && (
          <ContentContainer
            ml={0}
            px={[6, , , 9]}
            pb={[7, , , 8]}
            maxWidth="unset"
          >
            <WideContainer>
              {Label && (
                <Typography
                  color="text"
                  inline
                  mb={1}
                  px={3}
                  py={2}
                  variant="h5"
                  sx={{
                    backgroundColor: theme.colors.yellow,
                    display: 'inline-block',
                    fontFamily: 'Helvetica Neue LT W05_43 Lt Ex !important',
                    fontSize: '36px',
                  }}
                >
                  {Label}
                </Typography>
              )}
              {Title && (
                <Typography
                  component="h1"
                  variant="h2"
                  width={[1, , 2 / 3]}
                  sx={{
                    fontFamily: 'Helvetica Neue LT W05_43 Lt Ex !important',
                    fontSize: '36px',
                  }}
                >
                  {Title}
                </Typography>
              )}
            </WideContainer>
          </ContentContainer>
        )}
      </StyledImage>
    </Box>
  </TypographyContextProvider>
);

export default HeaderHeroImageSection;
